<template>
  <div id="config-forms-wrapper">
    <item-tile
      v-for="(item, index) in forms"
      :key="index"
      class="form-item"
      :heading="item.name"
      :selected="true"
      :secondaryIcons="['pencil']"
      @primary-icon-clicked="initiateDelete(item, index)"
      @secondary-icon-clicked="initiateEdit(item, index)"
    />
    <item-tile
      class="form-item"
      :selected="false"
      heading="Add New Form"
      @click="toggleCreationActive"
    />
    <form-creation
      v-if="creationActive"
      :form="edit.form"
      :processing="edit.processing"
      @close="toggleCreationActive"
      @add-form="callDb"
    />
    <form-delete
      v-if="del.form"
      :subject="del.form"
      :processing="del.processing"
      @close="closeDelete"
      @confirm="confirmDelete"
    />
  </div>
</template>

<script>
import FormCreation from "./Modals/Forms/FormCreation.vue";
import FormDelete from "./Modals/Forms/Delete.vue";
import ItemTile from "@/Components/UI/ItemTile.vue";
export default {
  data() {
    return {
      creationActive: false,
      deleteActive: false,
      edit: {
        processing: false,
        form: undefined,
        index: undefined,
      },
      del: {
        processing: false,
        form: undefined,
        index: undefined,
      },
    };
  },
  computed: {
    forms() {
      return this.$store.getters.forms;
    },
  },
  methods: {
    toggleCreationActive() {
      this.creationActive = !this.creationActive;
      if (this.creationActive === false) {
        this.edit = {
          form: undefined,
          index: undefined,
        };
      }
    },
    initiateEdit(item, index) {
      this.edit.form = item;
      this.edit.index = index;
      this.toggleCreationActive();
    },
    initiateDelete(item, index) {
      this.del.form = item;
      this.del.index = index;
    },
    closeDelete() {
      this.del = {
        processing: false,
        form: undefined,
        index: undefined,
      };
    },
    async confirmDelete() {
      this.del.processing = true;
      await this.$store.dispatch("updateConfig", {
        key: {
          userId: this.$store.state.user.userId,
          tenantId: this.$store.state.user.tenantId,
        },
        index: this.del.index,
        category: "forms",
        operation: "delete",
        api_version: this.$store.state.businessSettings.api_version,
      });
      this.closeDelete();
    },
    async callDb(subject) {
      this.edit.processing = true;
      let updatePacket = {
        key: {
          userId: this.$store.state.user.userId,
          tenantId: this.$store.state.user.tenantId,
        },
        subject: subject,
        category: "forms",
        api_version: this.$store.state.businessSettings.api_version,
      };
      if (this.edit.index) {
        updatePacket = {
          ...updatePacket,
          operation: "edit",
          index: this.edit.index,
        };
      } else {
        updatePacket = {
          ...updatePacket,
          operation: "add",
        };
      }
      await this.$store.dispatch("updateConfig", updatePacket);
      this.toggleCreationActive();
      this.edit.processing = false;
    },
  },
  created() {},
  components: {
    ItemTile,
    FormCreation,
    FormDelete,
  },
  props: [],
};
</script>
<style scoped>
@media screen {
  #config-forms-wrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-items: flex-start;
    box-sizing: border-box;
  }

  .form-item {
    margin: 20px;
    background-color: var(--secondaryColor);
  }
  @media (min-width: 800px) {
    .form-item {
      margin: 30px;
    }
  }
}
</style>
